// external imports
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
// internal imports
import "chart.js/auto";
import { FontColor, FourGround } from "../../assets/js/theme";

import {
  PersonBoundingBox,
  PersonFill,
  PenFill,
  ThreeDots,
  CardChecklist,
  FileEarmarkExcel,
  JournalCode,
  CreditCard2Front,
  KeyFill,
  Award,
  FiletypeCsv,
  TrashFill,
  FiletypePy,
  FilterCircle,
  People,
  CashStack,
  Phone,
  ArrowClockwise,
  BoxArrowInLeft,
  ClockHistory,
} from "react-bootstrap-icons";
import {
  csutomerWebhookRegister,
  getAdminIspOwners,
  getCreateCsutomerLoginCredential,
  getIspOwner,
  getIspOwners,
  getReseller,
  resetSerialNumber,
} from "../../features/apiCallAdmin";
import Table from "../../components/table/Table";
import EditModal from "./modal/EditModal";
import "./home.css";
import DetailsModal from "./modal/DetailsModal";
import Note from "./modal/Note";
import FileUpload from "./modal/FileUpload";
import Permissions from "./modal/Permissions";
import AddProprietorModal from "./modal/AddProprietorModal";
import Invoices from "../invoiceList/Invoices";
import { badge } from "../../components/common/Utils";
import PasswordReset from "../../components/modals/passwordReset/PasswordReset";
import districtsJSON from "../../bdAddress/bd-districts.json";
import { CSVLink } from "react-csv";
import DeleteByMobileModal from "./modal/DeleteByMobileModal";
import { useTranslation } from "react-i18next";
import IspOwnerCustomerUpdate from "./modal/IspOwnerCustomerUpdate";
import { Accordion } from "react-bootstrap";
import Loader from "../../components/common/Loader";
import useDataState from "../../hooks/useDataState";
import PaginatedTable from "../../components/table/PaginatedTable";

const districts = districtsJSON.districts;

export default function Home() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // get isp owner
  let ispOwners = useSelector((state) => state.admin?.ispOwners);

  // get user role from redux
  const userRole = useSelector((state) => state.persistedReducer.auth.role);

  // loading
  const [isLoading, setIsLoading] = useState(false);

  // clint data state
  const [clintData, setClintData] = useState({
    data: [],
    totalPages: 0,
  });

  // modal handle status
  const [modalStatus, setModalStatus] = useState("");
  const [show, setShow] = useState(false);

  // set owner at local state
  const [ownerId, setOwnerId] = useState();
  const [permissionId, setPermissionId] = useState("");

  // user id state
  const [userId, setUserId] = useState();

  // set owner name
  const [companyName, setCompanyName] = useState();

  // mikrotik status state
  const [mikrotikStatus, setMikrotikStatus] = useState("");

  // billing cycle response data state
  const [billingCycle, setBillingCycle] = useState("");

  //reseller data state
  const [resellerBillCycleData, setResellerBillCycleData] = useState("");

  // Owner id
  const [ispOwnerId, setIspOwnerId] = useState("");

  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");

  // get user data set from useDataState hooks
  const { filterOptions, setFilterOption } = useDataState();

  const searchParams = new URLSearchParams({
    page: 1,
    limit: 50,
  }).toString();

  // api call
  useEffect(() => {
    getAdminIspOwners(dispatch, setIsLoading, searchParams);
  }, []);

  useEffect(() => {
    if (ispOwners) {
      setClintData((prev) => {
        return {
          data: ispOwners?.data ?? [],
          page: ispOwners?.page ?? 1,
          limit: ispOwners?.limit ?? 100,
          total: ispOwners?.total ?? prev?.total ?? 0,
          totalPages: ispOwners?.totalPages ?? prev?.totalPages ?? 0,
          nextCursor: ispOwners?.nextCursor ?? null,
          previousCursor: ispOwners?.previousCursor ?? null,
        };
      });
    }
  }, [ispOwners]);

  // reload handler
  const reloadHandler = () => {
    getAdminIspOwners(dispatch, setIsLoading, searchParams);
  };

  // edit modal method
  const editModal = (ispOwnerId) => {
    setOwnerId(ispOwnerId);
  };

  // details modal handle
  const detailsModal = (showDetailsId) => {
    setOwnerId(showDetailsId);
  };

  // Reset Customer Serial Number
  const resetSerialNumberHandler = (ispOwnerId) => {
    resetSerialNumber(ispOwnerId);
  };

  const noteModal = (noteId, companyName) => {
    setOwnerId(noteId);
    setCompanyName(companyName);
  };

  const fileModal = (ownerId, mtk) => {
    setOwnerId(ownerId);
    setMikrotikStatus(mtk);
  };

  const ipsOwnerBillingCycleHandler = (ispOwner) => {
    let confirm = window.confirm(
      "The isp owner wants to continue the billing cycle",
    );
    if (confirm) {
      getIspOwner(ispOwner?.id, setBillingCycle);
    }
  };

  //reseller billing cycle
  const resellerBillingCycleHandle = (ispOwner) => {
    let confirm = window.confirm("Reseller wants to continue billing cycle");
    if (confirm) {
      getReseller(ispOwner?.id, setResellerBillCycleData);
    }
  };

  // create customer login credential
  const createCustomerLoginCredential = (ispOwner) => {
    getCreateCsutomerLoginCredential(ispOwner?.mobile);
  };

  // create customer webhook
  const createCustomerWebhookHandler = (ispOwner) => {
    const sendingData = {
      name: ispOwner.name,
      shunnoId: Number(ispOwner.netFeeId).toString(),
      clientApp: "NETFEE",
      password: `${ispOwner.mobile}NF`,
      role: "WEBHOOK_USER",
    };

    // webhook api call
    csutomerWebhookRegister(sendingData);
  };

  // ispOwner export data csv table header
  const ispOwnerForCsVTableInfoHeader = [
    { label: "Id", key: "netFeeId" },
    { label: "Company", key: "company" },
    { label: "Name", key: "name" },
    { label: "Mobile", key: "mobile" },
    { label: "MTK", key: "hasMikrotik" },
    { label: "SMS", key: "smsBalance" },
    { label: "Customer", key: "customerLimit" },
    { label: "Rate", key: "packageRate" },
    { label: "Payment", key: "paymentStatus" },
    { label: "Status", key: "status" },
    { label: "Address", key: "address" },
    { label: "Created Date", key: "createdAt" },
    { label: "Bill Date", key: "monthlyDueDate" },
  ];

  //ispOwner export data
  const ispOwnerForCsVTableInfo = clintData?.data?.map((ispOwner) => {
    return {
      netFeeId: ispOwner.netFeeId,
      company: ispOwner.company,
      name: ispOwner.name,
      mobile: ispOwner.mobile,
      hasMikrotik: ispOwner.bpSettings.hasMikrotik ? "YES" : "NO",
      smsBalance: ispOwner.smsBalance,
      customerLimit: ispOwner.bpSettings.customerLimit,
      packageRate: ispOwner.bpSettings.packageRate,
      paymentStatus: ispOwner.bpSettings.paymentStatus,
      status: ispOwner.status,
      address: ispOwner.address,
      createdAt: moment(ispOwner.createdAt).format("DD MMM YY hh:mm a"),
      monthlyDueDate: moment(ispOwner.bpSettings.monthlyDueDate).format(
        "DD MMM YY hh:mm a",
      ),
    };
  });

  useEffect(() => {
    if (billingCycle) {
      alert(billingCycle.msg);
    }
  }, [billingCycle]);

  useEffect(() => {
    if (resellerBillCycleData) {
      alert(resellerBillCycleData.msg);
    }
  }, [resellerBillCycleData]);

  // single customer activity log handle
  const handleCustomerActivityLog = (data) => {
    navigate(`/admin/activity-log/${data?.id}`, {
      state: { ...data, role: "ispOwner" },
    });
  };

  // table column
  const columns = React.useMemo(
    () => [
      {
        width: "5%",
        Header: "Id",
        accessor: "netFeeId",
      },
      {
        width: "15%",
        Header: "Company",
        accessor: "company",
        Cell: ({ row: { original } }) => (
          <div>
            <strong>{original?.company}</strong>
            <p>{original?.address}</p>
          </div>
        ),
      },
      {
        width: "15%",
        Header: "Name/Mobile",
        accessor: (data) => `${data?.name} ${data?.mobile}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p>{original?.name}</p>
            <p
              title="IspOwner mobile"
              className="d-flex gap-1 align-items-center"
            >
              <Phone size={18} className="text-info" />
              <span>{original?.mobile}</span>
            </p>
          </div>
        ),
      },
      {
        width: "6%",
        accessor: "bpSettings.hasMikrotik",
        Header: "MTK",
        Cell: ({ cell: { value } }) => {
          return value ? "YES" : "NO";
        },
      },
      {
        width: "6%",
        Header: "SMS",
        accessor: "smsBalance",
        Cell: ({ row: { original } }) => (
          <div>
            {original.smsBalance +
              original.maskingSmsBalance +
              original.fixedNumberSmsBalance}
          </div>
        ),
      },
      {
        width: "10%",
        Header: "User/Rate",
        accessor: (data) =>
          `${data?.bpSettings?.customerLimit} ${data?.bpSettings?.packageRate}`,
        Cell: ({ row: { original } }) => (
          <div>
            <p
              title="Customer limit"
              className="d-flex gap-1 align-items-center"
            >
              <People size={16} className="text-primary" />
              {original?.bpSettings.customerLimit}
            </p>
            <p
              title="Customer package rate"
              className="d-flex gap-1 align-items-center"
            >
              <CashStack size={18} className="text-success" />
              <span>{original?.bpSettings.packageRate}</span>
            </p>
          </div>
        ),
      },
      {
        width: "8%",
        Header: "Status",
        accessor: (data) => data?.bpSettings?.monthlyPaymentStatus,
        Cell: ({ row: { original } }) => (
          <div className="text-center">
            <p>{badge(original?.status)}</p>
            <p>{badge(original?.bpSettings?.monthlyPaymentStatus)}</p>
          </div>
        ),
      },
      {
        width: "13%",
        Header: "Created/Bill Date",
        accessor: (data) => data?.bpSettings?.monthlyDueDate,
        Cell: ({ row: { original } }) => (
          <div className="d-flex">
            <div>
              <p>{moment(original?.createdAt).format("DD MMM YY hh:mm A")}</p>
              <p>
                {moment(original?.bpSettings?.monthlyDueDate).format(
                  "DD MMM YY hh:mm A",
                )}
              </p>
            </div>
          </div>
        ),
      },
      {
        width: "6%",
        Header: "Reg",
        accessor: "bpSettings.paymentStatus",
        Cell: ({ row: { original } }) => (
          <div className="text-center">
            <p>{badge(original?.bpSettings?.paymentStatus)}</p>
          </div>
        ),
      },
      {
        width: "5%",
        Header: () => <div className="text-center">Action</div>,
        id: "option",
        Cell: ({ row: { original } }) => {
          return (
            <div className="text-center">
              <div className="dropdown">
                <ThreeDots
                  className="dropdown-toggle ActionDots"
                  id="areaDropdown"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />
                <ul className="dropdown-menu" aria-labelledby="areaDropdown">
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#showCustomerDetails"
                    onClick={() => {
                      detailsModal(original._id);
                      setModalStatus("details");
                      setShow(true);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <PersonFill />
                        <p className="actionP">Details</p>
                      </div>
                    </div>
                  </li>

                  <li
                    onClick={() => {
                      setPermissionId(original?._id);
                      setModalStatus("permission");
                      setShow(true);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <CreditCard2Front />
                        <p className="actionP">Permissions</p>
                      </div>
                    </div>
                  </li>
                  <li
                    onClick={() => {
                      editModal(original._id);
                      setModalStatus("edit");
                      setShow(true);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <PenFill />
                        <p className="actionP">Edit</p>
                      </div>
                    </div>
                  </li>

                  <li
                    onClick={() => {
                      setOwnerId(original?._id);
                      setCompanyName(original?.company);
                      setModalStatus("invoice");
                      setShow(true);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <PersonBoundingBox />
                        <p className="actionP">Invoice</p>
                      </div>
                    </div>
                  </li>
                  <li
                    onClick={() => {
                      setIspOwnerId(original?._id);
                      setCompanyName(original?.company);
                      setModalStatus("multiple");
                      setShow(true);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <i class="fa-solid fa-pen-to-square"></i>
                        <p className="actionP">Multiple Customer Update</p>
                      </div>
                    </div>
                  </li>
                  <Link to={`/admin/netFee/support/${original._id}`}>
                    <li>
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <Award />
                          <p className="actionP">NetFee Support</p>
                        </div>
                      </div>
                    </li>
                  </Link>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#clientNoteModal"
                    onClick={() => {
                      noteModal(original._id, original.company);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <CardChecklist />
                        <p className="actionP">Note</p>
                      </div>
                    </div>
                  </li>
                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#inventoryAddModal"
                    onClick={() => {
                      setOwnerId(original._id);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <CardChecklist />
                        <p className="actionP">Add Inventory</p>
                      </div>
                    </div>
                  </li>
                  <li onClick={() => resetSerialNumberHandler(original._id)}>
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <JournalCode />
                        <p className="actionP">Reset Serial</p>
                      </div>
                    </div>
                  </li>

                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#fileUploadModal"
                    onClick={() => {
                      if (!original.bpSettings.hasMikrotik) {
                        fileModal(original._id, "noMikrotik");
                      } else if (original.bpSettings.hasMikrotik) {
                        fileModal(original._id, "mikrotik");
                      }
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <FileEarmarkExcel />
                        <p className="actionP">CSV File Upload</p>
                      </div>
                    </div>
                  </li>

                  <li
                    data-bs-toggle="modal"
                    data-bs-target="#resetPassword"
                    onClick={() => {
                      setUserId(original.user);
                      setModalStatus("password");
                      setShow(true);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <KeyFill />
                        <p className="actionP">Password Reset</p>
                      </div>
                    </div>
                  </li>
                  <li
                    onClick={() => {
                      ipsOwnerBillingCycleHandler(original);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <i class="fa-solid fa-money-bill-wave"></i>
                        <p className="actionP">IspOwner Billing Cycle</p>
                      </div>
                    </div>
                  </li>
                  <li
                    onClick={() => {
                      resellerBillingCycleHandle(original);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <i class="fa-solid fa-money-bill-wave"></i>
                        <p className="actionP">Reseller Billing Cycle</p>
                      </div>
                    </div>
                  </li>

                  <li
                    onClick={() => {
                      createCustomerLoginCredential(original);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <BoxArrowInLeft />
                        <p className="actionP">
                          Create Customer Login Credential
                        </p>
                      </div>
                    </div>
                  </li>

                  {userRole === "superadmin" && (
                    <li
                      onClick={() => {
                        createCustomerWebhookHandler(original);
                      }}
                    >
                      <div className="dropdown-item">
                        <div className="customerAction">
                          <FiletypePy />
                          <p className="actionP">Create Customer Webhook</p>
                        </div>
                      </div>
                    </li>
                  )}

                  <li
                    onClick={() => {
                      handleCustomerActivityLog(original);
                    }}
                  >
                    <div className="dropdown-item">
                      <div className="customerAction">
                        <ClockHistory />
                        <p className="actionP">Activity Log</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      },
    ],
    [],
  );

  // filter inputs options
  const filterInputs = [
    {
      name: "status",
      type: "select",
      id: "status",
      value: filterOptions.status,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          status: e.target.value,
        });
      },
      options: [
        {
          text: "New",
          value: "new",
        },
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
        {
          text: "Banned",
          value: "banned",
        },
        {
          text: "Deleted",
          value: "deleted",
        },
        {
          text: "Trial",
          value: "trial",
        },
      ],
      firstOptions: t("status"),
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "monthlyPaymentStatus",
      type: "select",
      id: "monthlyPaymentStatus",
      value: filterOptions.monthlyPaymentStatus,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          monthlyPaymentStatus: e.target.value,
        });
      },
      options: [
        {
          text: t("paid"),
          value: "paid",
        },
        {
          text: t("unpaid"),
          value: "unpaid",
        },
      ],
      firstOptions: t("paymentStatus"),
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "executeBillingCycle",
      type: "select",
      id: "executeBillingCycle",
      value: filterOptions.executeBillingCycle,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          executeBillingCycle: e.target.value,
        });
      },
      options: [
        {
          text: "Run Billing Cycle",
          value: "true",
        },
        {
          text: `Don't Billing Cycle`,
          value: "false",
        },
      ],
      firstOptions: "Execute Billing Cycle",
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "customerType",
      type: "select",
      id: "customerType",
      value: filterOptions.customerType,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          customerType: e.target.value,
        });
      },
      options: [
        {
          text: "PPPoE",
          value: "pppoe",
        },
        {
          text: "Static",
          value: "static",
        },
        {
          text: "Hotspot",
          value: "hotspot",
        },
      ],
      firstOptions: "Customer Type",
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "hasMikrotik",
      type: "select",
      id: "hasMikrotik",
      value: filterOptions.hasMikrotik,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          hasMikrotik: e.target.value,
        });
      },
      options: [
        {
          text: "With Mikrotik",
          value: "true",
        },
        {
          text: "WithOut Mikrotik",
          value: "false",
        },
      ],
      firstOptions: "Mikrotik",
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "hasOLT",
      type: "select",
      id: "hasOLT",
      value: filterOptions.hasOLT,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          hasOLT: e.target.value,
        });
      },
      options: [
        {
          text: "With OLT",
          value: "true",
        },
        {
          text: "WithOut OLT",
          value: "false",
        },
      ],
      firstOptions: "OLT",
      textAccessor: "text",
      valueAccessor: "value",
    },
    {
      name: "district",
      type: "select",
      id: "district",
      value: filterOptions.district,
      isVisible: true,
      disabled: false,
      onChange: (e) => {
        setFilterOption({
          ...filterOptions,
          district: e.target.value,
        });
      },
      options: districts,
      firstOptions: "All District",
      textAccessor: "name",
      valueAccessor: "name",
    },
    {
      name: "startCreateDate",
      type: "date",
      id: "startCreateDate",
      isVisible: true,
      disabled: false,
      placeholderText: t("startCreateDate"),
      component: "DatePicker",
      dateFormat: "yyyy MM dd hh:mm a",
      timeIntervals: 60,
      showTimeSelect: "showTimeSelect",
      selected: filterOptions?.startCreateDate,
      onChange: (date) => {
        setFilterOption({
          ...filterOptions,
          startCreateDate: date,
        });
      },
    },
    {
      name: "endCreateDate",
      type: "date",
      id: "endCreateDate",
      isVisible: true,
      disabled: false,
      placeholderText: t("endCreateDate"),
      component: "DatePicker",
      dateFormat: "yyyy MM dd hh:mm a",
      timeIntervals: 60,
      showTimeSelect: "showTimeSelect",
      selected: filterOptions?.endCreateDate,
      onChange: (date) => {
        setFilterOption({
          ...filterOptions,
          endCreateDate: date,
        });
      },
    },
    {
      name: "startBillDate",
      type: "date",
      id: "startBillDate",
      isVisible: true,
      disabled: false,
      placeholderText: t("startBillDate"),
      component: "DatePicker",
      dateFormat: "yyyy MM dd hh:mm a",
      timeIntervals: 60,
      showTimeSelect: "showTimeSelect",
      selected: filterOptions.startBillDate,
      onChange: (date) => {
        setFilterOption({
          ...filterOptions,
          startBillDate: date,
        });
      },
    },
    {
      name: "endBillDate",
      type: "date",
      id: "endBillDate",
      isVisible: true,
      disabled: false,
      placeholderText: t("endBillDate"),
      component: "DatePicker",
      dateFormat: "yyyy MM dd hh:mm a",
      timeIntervals: 60,
      showTimeSelect: "showTimeSelect",
      selected: filterOptions.endBillDate,
      onChange: (date) => {
        setFilterOption({
          ...filterOptions,
          endBillDate: date,
        });
      },
    },
  ];

  const handleTableQuerySubmition = (query, setTableLoading) => {
    const {
      page = ispOwners?.page,
      limit = ispOwners?.limit,
      nextCursor,
      previousCursor,
      search,
    } = query;

    const {
      status,
      monthlyPaymentStatus,
      executeBillingCycle,
      queueType,
      customerType,
      hasMikrotik,
      hasOLT,
      district,
      startCreateDate,
      endCreateDate,
      startBillDate,
      endBillDate,
    } = filterOptions;

    const buieldQuery = {
      page,
      limit,
      nextCursor,
      previousCursor,
      search,
      status,
      monthlyPaymentStatus,
      executeBillingCycle,
      queueType,
      customerType,
      hasMikrotik,
      hasOLT,
      district,
      startCreateDate,
      endCreateDate,
      startBillDate,
      endBillDate,
    };

    const searchParams = new URLSearchParams(
      Object.entries(buieldQuery).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    ).toString();

    const loading = setTableLoading ? setTableLoading : setIsLoading;

    getAdminIspOwners(dispatch, loading, searchParams);
  };

  const handleTableFilterdQuerySubmition = (query) => {
    const {
      status,
      monthlyPaymentStatus,
      executeBillingCycle,
      queueType,
      customerType,
      hasMikrotik,
      hasOLT,
      district,
      startCreateDate,
      endCreateDate,
      startBillDate,
      endBillDate,
    } = query;

    const buieldQuery = {
      page: 1,
      limit: 50,
      status,
      monthlyPaymentStatus,
      executeBillingCycle,
      queueType,
      customerType,
      hasMikrotik,
      hasOLT,
      district,
      startCreateDate,
      endCreateDate,
      startBillDate,
      endBillDate,
    };

    const searchParams = new URLSearchParams(
      Object.entries(buieldQuery).filter(
        ([_, value]) => value !== undefined && value !== null && value !== "",
      ),
    ).toString();

    getAdminIspOwners(dispatch, setIsLoading, searchParams);
  };

  const handleFilterReset = () => {
    if (Object.keys(filterOptions).length > 0) {
      const resetFilterOptions = Object.fromEntries(
        filterInputs.map((input) => [input.name, ""]),
      );

      setFilterOption(resetFilterOptions);

      handleTableFilterdQuerySubmition(resetFilterOptions);
    }
  };

  return (
    <>
      <FontColor>
        <FourGround>
          <div className="collectorTitle d-flex justify-content-between px-4">
            <div className="component_name">
              {userRole === "admin" ? "Admin Dashboard" : "Super Admin"}
            </div>

            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  if (!activeKeys) {
                    setActiveKeys("filter");
                  } else {
                    setActiveKeys("");
                  }
                }}
                title={t("filter")}
              >
                <FilterCircle className="addcutmButton" />
              </div>

              <div className="reloadBtn">
                {isLoading ? (
                  <Loader />
                ) : (
                  <ArrowClockwise
                    className="arrowClock"
                    title="Refresh"
                    onClick={reloadHandler}
                  />
                )}
              </div>

              <TrashFill
                size={23}
                className="addcutmButton"
                onClick={() => {
                  setModalStatus("mobileNumberSearch");
                  setShow(true);
                }}
              />

              <CSVLink
                data={ispOwnerForCsVTableInfo}
                filename={ispOwners.company}
                headers={ispOwnerForCsVTableInfoHeader}
                title="IspOwner Customer CSV"
              >
                <FiletypeCsv className="addcutmButton" />
              </CSVLink>
            </div>
          </div>
        </FourGround>

        <FourGround>
          <div className="mt-2">
            <Accordion alwaysOpen activeKey={activeKeys}>
              <Accordion.Item eventKey="filter">
                <Accordion.Body>
                  <div className="displayGrid6">
                    {filterInputs.map((item) => {
                      if (item.isVisible) {
                        return item.type === "select" ? (
                          <select
                            className="form-select shadow-none mt-0"
                            onChange={item.onChange}
                            value={item.value}
                          >
                            <option value="">{item.firstOptions}</option>
                            {item.options?.map((opt) => (
                              <option value={opt[item.valueAccessor]}>
                                {opt[item.textAccessor]}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <div>
                            <DatePicker
                              className="form-control mt-0"
                              {...item}
                              timeIntervals
                              showTimeSelect
                            />
                          </div>
                        );
                      }
                    })}

                    <div className="displayGrid1">
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        onClick={() =>
                          handleTableFilterdQuerySubmition(filterOptions)
                        }
                      >
                        {t("filter")}
                      </button>
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleFilterReset}
                      >
                        {t("reset")}
                      </button>
                    </div>

                    <Link to={"/admin/all-comments"}>
                      <div className="all-comment-btn">
                        <button className="btn btn-outline-success w-100">
                          All Comment
                        </button>
                      </div>
                    </Link>

                    {userRole === "superadmin" && (
                      <Link to={"/admin/invoices"}>
                        <div className="all-comment-btn">
                          <button className="btn btn-outline-primary w-100">
                            Invoice
                          </button>
                        </div>
                      </Link>
                    )}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className="collectorWrapper pb-2">
              <PaginatedTable
                isLoading={isLoading}
                columns={columns}
                data={clintData}
                callTableQueryApi={handleTableQuerySubmition}
              />
            </div>
          </div>
        </FourGround>
      </FontColor>

      {/* owner permissions  */}
      {modalStatus === "permission" && (
        <Permissions show={show} setShow={setShow} ownerId={permissionId} />
      )}

      {modalStatus === "edit" && (
        <EditModal show={show} setShow={setShow} ownerId={ownerId} />
      )}

      {modalStatus === "details" && (
        <DetailsModal {...{ show, setShow, ownerId }} />
      )}

      <AddProprietorModal ownerId={ownerId} />

      {/* customer invoice list */}
      {modalStatus === "invoice" && (
        <Invoices
          ownerId={ownerId}
          companyName={companyName}
          isOpen={show}
          setIsOpen={setShow}
        />
      )}

      {/* owner multiple customer update */}
      {modalStatus === "multiple" && (
        <IspOwnerCustomerUpdate
          isShow={show}
          setIsShow={setShow}
          ispOwnerId={ispOwnerId}
          companyName={companyName}
        />
      )}

      <Note ownerId={ownerId} companyName={companyName} />
      <FileUpload ownerID={ownerId} mikrotikStatus={mikrotikStatus} />

      {/* user mobile number search and delete */}
      {modalStatus === "mobileNumberSearch" && (
        <DeleteByMobileModal show={show} setShow={setShow} />
      )}

      {/* password reset modal */}
      {modalStatus === "password" && (
        <PasswordReset show={show} setShow={setShow} userId={userId} />
      )}
    </>
  );
}
